import { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import MobileLayout from '../layouts/MobileLayout';
// guards
import AuthGuard from '../guards/AuthGuard';
import GuestGuard from '../guards/GuestGuard';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

export default function Router() {
  return useRoutes([
    {
      path: 'login',
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    { path: '/', element: <Navigate to="/menu" replace /> },
    {
      path: '/',
      element: (
        <AuthGuard>
          <MobileLayout />
        </AuthGuard>
      ),
      children: [
        { path: 'menu', element: <Home /> },
        { path: 'dish/:id', element: <DishDetail /> },
        { path: 'packages', element: <Packages /> },
        { path: 'packages/:id', element: <PackageDetail /> },
        { path: 'cart', element: <Cart /> },
        { path: 'checkout', element: <Checkout /> },
        { path: 'orders', element: <Orders /> },
        { path: 'orders/:id', element: <OrderDetail /> },
        { path: 'profile', element: <Profile /> },
        { path: 'profile/cashback', element: <Cashback /> },
        { path: 'profile/nutrition', element: <Nutrition /> },
        { path: 'profile/favorites', element: <Favorites /> },
        { path: 'profile/edit', element: <ProfileEdit /> },
        { path: 'notifications', element: <Notifications /> },
      ],
    },
    { path: '*', element: <Navigate to="/menu" replace /> },
  ]);
}

const Login = Loadable(lazy(() => import('../pages/Login')));
const Home = Loadable(lazy(() => import('../pages/Home')));
const DishDetail = Loadable(lazy(() => import('../pages/DishDetail')));
const Packages = Loadable(lazy(() => import('../pages/Packages')));
const PackageDetail = Loadable(lazy(() => import('../pages/PackageDetail')));
const Cart = Loadable(lazy(() => import('../pages/Cart')));
const Checkout = Loadable(lazy(() => import('../pages/Checkout')));
const Orders = Loadable(lazy(() => import('../pages/Orders')));
const OrderDetail = Loadable(lazy(() => import('../pages/OrderDetail')));
const Profile = Loadable(lazy(() => import('../pages/Profile')));
const Cashback = Loadable(lazy(() => import('../pages/Cashback')));
const Nutrition = Loadable(lazy(() => import('../pages/Nutrition')));
const Favorites = Loadable(lazy(() => import('../pages/Favorites')));
const ProfileEdit = Loadable(lazy(() => import('../pages/ProfileEdit')));
const Notifications = Loadable(lazy(() => import('../pages/Notifications')));
